import { Media } from 'react-bootstrap'
import Link from 'next/link'

function DiscoverWelcome() {
    return (
        <Media className="my-5 py-3 mx-lg-5 px-lg-5">
            <img width={120} src="../images/test/discover.png" alt="Generic placeholder" className="img-fluid mr-4"/>
            <Media.Body>
                <h5 className="h6"><strong>Join the Discover Shaklee Facebook Group </strong></h5>
                <p className="h7">
                    Connect with our supportive community and get notified when <br/>
                    we add new wellness content and live stream wellness events. 
                </p>
                <Link href={"https://www.facebook.com/groups/discovershaklee"} ><a className="border-green border text-uppercase font-weight-bold text-green px-4 btn rounded-0 d-inline-block h7 btn-trans-green">Join the Group</a></Link>
            </Media.Body>
        </Media>
    )
}

export default DiscoverWelcome
